import request from '../common/request.js';

//添加管理员
export function AddAdmin(payload) {
    return request.post('/admin/AddAdmin', payload);
}

//获取管理员列表
export function GetAdminList(payload) {
    return request.post('/admin/GetAdminList', payload);
}

//更新管理员列表
export function UpdateAdmin(payload) {
    return request.post('/admin/UpdateAdmin', payload);
}


//删除管理员列表
export function DeleteAdmin(payload) {
    return request.get('/admin/DeleteAdmin', payload);
}